import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const legacyJsdKnowledgeRoute: InvariantJiraRoute = {
	name: 'legacy-jsd-knowledge',
	path: '/projects/:projectKey/knowledge/:page?',
};
